import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from "moment";
import { connect } from 'react-redux';
import { compose } from "recompose";
import { withCookies } from 'react-cookie';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';

import { userActions, projectActions, tasksissuesActions, timesheetActions, commonActions } from '../../_actions';
import IntegrationReactSelect from '../Common/IntegrationReactSelect';
import Progress from '../Common/Progress';

const imageUrl_SpiderWeb02 = require(`../../images/GameTheme/Background/Spiderweb02.png`)
const imageUrl_KULO1 = require(`../../images/GameTheme/Background/KULO_01.png`)
const imageUrl_KULO2 = require(`../../images/GameTheme/Background/KULO_02.png`)
const imageUrl_SenceFloor = require(`../../images/GameTheme/Background/sence_floor.png`)
const imageUrl_Torch01 = require(`../../images/GameTheme/Background/Torch01.png`)

const formatter1 = 'YYYY-MM-DD';

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
    paper: {
        position: 'absolute',
        width: '80%',
        maxHeight: '80%',
        [theme.breakpoints.down('sm')]: {
            height: '90%',
            overflow: 'scroll',
        },
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    textField: {
        width: '90%',
        margin: theme.spacing.unit,
    },
    group: {
        flexDirection: 'row',
    },
    margin: {
        marginLeft: -(theme.spacing.unit * 4),
        marginTop: theme.spacing.unit * 3,
    },
    setMarginTop: {
        marginTop: `${theme.spacing.unit * 3}px`,
        margin: `${theme.spacing.unit}px`,
    },
    setMarginBottom: {
        marginBottom: `${theme.spacing.unit * 3}px`,
    },
    padding: {
        padding: `0 ${theme.spacing.unit * 2}px`,
    },
});

function getModalStyle(checkedGameTheme) {
    const top = 50;
    const left = 50;

    if (checkedGameTheme) {
        return {
            top: `${top}%`,
            left: `${left}%`,
            transform: `translate(-${top}%, -${left}%)`,
            backgroundImage: `url(${imageUrl_SenceFloor})`,
            backgroundPosition: 'left 101%',
            backgroundRepeat: 'repeat-x',
            backgroundSize: '30%'
        }
    }
    else {
        return {
            top: `${top}%`,
            left: `${left}%`,
            transform: `translate(-${top}%, -${left}%)`,
        }
    }
}

class FormComponent extends Component {
    constructor(props) {
        super(props);
        var now = new Date();
        var dateTime = moment(now).format(formatter1);

        this.state = {
            openProgress: false,
            mode: 'ADD',
            tasksOpen: false,
            modalTitle: 'Create Timesheet',

            timesheetId: '',
            date: dateTime,
            hours: '',
            projectId: '',
            taskId: '',
            subCategoryId: '',
            taskNotes: '',
            value: 3, //satisfaction

            dateValid: true,
            hoursValid: true,
            subCategoryIdValid: true,
            taskNotesValid: true,

            tabValue: 1,
            detailTimesheetOpen: false,
        };
    }

    componentDidMount() {
        this.props.dispatch(userActions.getAll());
        this.props.dispatch(projectActions.getAllByUserId(this.props.user.id));
        //this.props.dispatch(tasksissuesActions.getAllByUserId(this.props.user.id));
        this.props.dispatch(timesheetActions.getAllByDepartmentId(this.props.user.departmentId, this.props.user.id));
        this.props.dispatch(commonActions.getAll('SubCategory'));
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.open !== nextProps.open) {
            if (nextProps.TaskId !== '') {
                const tasksissues = nextProps.tasksissues;
                var tasksissuesData = tasksissues.items && tasksissues.items.find(function (item, index, array) {
                    return item.TaskId === nextProps.TaskId;
                });

                if (tasksissuesData) {
                    this.setState({
                        taskId: tasksissuesData.TaskId,
                        projectId: tasksissuesData.ProjectId,

                        mode: 'ADD',
                        modalTitle: 'Create Timesheet',
                    })
                }
            }
            else if (nextProps.TimesheetId !== '') {
                const timesheet = nextProps.timesheet;
                var timesheetData = timesheet.items && timesheet.items.find(function (item, index, array) {
                    return item.TimesheetId === nextProps.TimesheetId;
                });

                if (timesheetData) {
                    this.setState({
                        timesheetId: timesheetData.TimesheetId,
                        date: moment(timesheetData.Date).format(formatter1),
                        hours: timesheetData.Hours,
                        projectId: timesheetData.ProjectId,
                        taskId: timesheetData.TaskId,
                        subCategoryId: timesheetData.SubCategoryId,
                        taskNotes: timesheetData.Notes,
                        value: timesheetData.Satisfaction,

                        mode: 'EDIT',
                        modalTitle: 'Edit Timesheet',
                    })
                }
            }
            else if (nextProps.selectedDate !== this.props.selectedDate) {
                this.setState({
                    date: nextProps.selectedDate,
                })
            }
            else if (nextProps.ProjectId && nextProps.ProjectId !== '') {
                this.setState({
                    projectId: Number(nextProps.ProjectId),
                })
            }
            else {
                this.cleanData();
            }
        }
    }

    handleChange = name => event => {
        if (name === 'hours') {
            if (event.target.value % 0.25 !== 0) {
                //alert('Hours must be an increment of 0.25')
                this.setState({
                    hoursValid: false
                })
            }
            else if (event.target.value < 0.25) {
                //alert('Hours must be no less than 0.25')
                this.setState({
                    hoursValid: false
                })
            }
            else if (event.target.value > 999) {
                //alert('Hours must be no greater than 999')
                this.setState({
                    hoursValid: false
                })
            }
            else {
                this.setState({
                    [name + 'Valid']: true,
                });
            }
        }
        else {
            this.setState({
                [name + 'Valid']: true,
            });
        }

        this.setState({
            [name]: event.target.value
        });
    };

    handleSave = () => {
        let valid = true;

        if (this.state.date === '') {
            this.setState({
                dateValid: false
            })
            valid = false;
        }
        if (this.state.hours === '') {
            this.setState({
                hoursValid: false
            })
            valid = false;
        }
        if (this.state.subCategoryId === '') {
            this.setState({
                subCategoryIdValid: false
            })
            valid = false;
        }
        if (this.state.taskNotes === '') {
            this.setState({
                taskNotesValid: false
            })
            valid = false;
        }

        const DataProcessing = async () => {
            try {
                this.setState({
                    openProgress: true,
                })

                const inputData = {
                    "TimesheetId": this.state.timesheetId,
                    "Date": this.state.date,
                    "Hours": this.state.hours !== '' ? Number(this.state.hours) : 0,
                    "HoursOvertime": 0,
                    "CostUnitId": 0,
                    "SubCategoryId": this.state.subCategoryId,
                    "ProjectId": this.state.projectId !== '' ? this.state.projectId : 0,
                    "TaskId": this.state.taskId !== '' ? this.state.taskId : 0,
                    "Notes": this.state.taskNotes,
                    "Satisfaction": this.state.value,
                    "CreatedUserId": this.props.user.id,
                    "UpdatedUserId": this.props.user.id,
                    "DepartmentId": this.props.user.departmentId
                };

                if (this.state.mode === 'ADD') {
                    await this.props.dispatch(timesheetActions.insert(inputData));
                }
                else if (this.state.mode === 'EDIT') {
                    await this.props.dispatch(timesheetActions.update(inputData));
                }

                await this.props.dispatch(timesheetActions.getAllByDepartmentId(this.props.user.departmentId, this.props.user.id));
                await this.handleClose();
            } catch (e) {
                console.error("Problem", e)
            }
        }

        if (valid) {
            DataProcessing();
        }
    }

    cleanData() {
        var now = new Date();
        var dateTime = moment(now).format(formatter1);

        this.setState({
            openProgress: false,
            mode: 'ADD',
            modalTitle: 'Create Timesheet',

            timesheetId: '',
            date: dateTime,
            hours: '',
            projectId: '',
            taskId: '',
            subCategoryId: '',
            taskNotes: '',
            value: 3, //satisfaction

            dateValid: true,
            hoursValid: true,
            subCategoryIdValid: true,
            taskNotesValid: true,
        });
    }

    handleSelectData = (data) => {
        if (data.type === 'Projects') {
            this.setState({
                projectId: data.id
            })
        }
        else if (data.type === 'Tasks') {
            this.setState({
                taskId: data.id
            })
        }
        else if (data.type === 'SubCategory') {
            this.setState({
                subCategoryId: data.id
            })
        }
    }

    handleBottomNaviChange = (event, value) => {
        this.setState({ value });
    };

    handleClose = () => {
        this.props.close();
        this.cleanData()
    }

    render() {
        const { classes, projects, tasksissues, common, user } = this.props;
        const checkedGameTheme = this.props.cookies.get('checkedGameTheme') === 'true' ? true : false || false;

        return (
            <Paper>
                <Progress openProgress={this.state.openProgress} />
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.props.open}
                    onClose={this.handleClose}
                >
                    <div style={getModalStyle(checkedGameTheme)} className={classes.paper}>

                        {checkedGameTheme && <RenderGameTheme />}

                        <Typography id="modal-title" style={{ fontSize: 40, zIndex: 2 }}>
                            {this.state.modalTitle}
                        </Typography>
                        <Grid container>
                            <Grid item sm={12} md={5}>
                                <Grid container>
                                    <Grid item sm={12} md={6}>
                                        <TextField
                                            error={!this.state.dateValid}
                                            id="ate"
                                            label="*Date"
                                            type="date"
                                            className={classes.textField}
                                            value={this.state.date}
                                            onChange={this.handleChange('date')}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={6}>
                                        <TextField
                                            error={!this.state.hoursValid}
                                            id="standard-number"
                                            label="*Hour (s)"
                                            value={this.state.hours}
                                            onChange={this.handleChange('hours')}
                                            type="number"
                                            className={classes.textField}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            margin="normal"
                                        />
                                    </Grid>
                                </Grid>

                                <Typography style={{ color: '#d89797' }}>＊Sub - Category</Typography>
                                <IntegrationReactSelect
                                    disabledDefaultOptions={true}
                                    handleSelectData={this.handleSelectData}
                                    options={convertSubCategoryOptions(common.items_subcategory)}
                                    valid={this.state.subCategoryIdValid}
                                    value={this.state.subCategoryId}
                                    placeholder='*Sub-Category'
                                />
                                <Typography style={{ color: '#d89797' }}>Projects</Typography>
                                <IntegrationReactSelect
                                    handleSelectData={this.handleSelectData}
                                    options={convertProjectsOptions(projects.items, this.props.user.departmentId)}
                                    valid={true}
                                    value={this.state.projectId}
                                    placeholder='Projects'
                                />
                                <Typography style={{ color: '#d89797' }}>Tasks</Typography>
                                <IntegrationReactSelect
                                    handleSelectData={this.handleSelectData}
                                    options={convertTasksOptions(tasksissues.items, this.state.projectId, user.id)}
                                    valid={true}
                                    value={this.state.taskId}
                                    placeholder='Tasks'
                                />
                            </Grid>

                            <Grid item sm={12} md={7}>
                                <div style={{ height: '60px' }}></div>
                                <TextField
                                    multiline
                                    error={!this.state.taskNotesValid}
                                    id="standard-multiline-static"
                                    label="*Notes"
                                    rows="10"
                                    className={classes.textField}
                                    value={this.state.taskNotes}
                                    onChange={this.handleChange('taskNotes')}
                                    margin="normal"
                                    variant="outlined"
                                />
                            </Grid>
                        </Grid>

                        <Typography className={classes.setMarginTop} style={{ color: '#d89797' }}>Task Satisfaction</Typography>
                        <BottomNavigation
                            value={this.state.value}
                            onChange={this.handleBottomNaviChange}
                            showLabels
                            className={classes.setMarginBottom}
                            color="secondary"
                        >
                            <BottomNavigationAction label="Tears of Joy" icon={<span role="img" aria-label="100">😂😂😂</span>} />
                            <BottomNavigationAction label="Grinning" icon={<span role="img" aria-label="80">😄😄</span>} />
                            <BottomNavigationAction label="Smiling" icon={<span role="img" aria-label="60">😊</span>} />
                            <BottomNavigationAction label="Thinking" icon={<span role="img" aria-label="50">🤔</span>} />
                            <BottomNavigationAction label="Out of sorts" icon={<span role="img" aria-label="40">😠</span>} />
                            <BottomNavigationAction label="Angry" icon={<span role="img" aria-label="20">😤😤</span>} />
                            <BottomNavigationAction label="Very Angry" icon={<span role="img" aria-label="0">😡😡😡</span>} />
                        </BottomNavigation>

                        <Button color="secondary" variant="outlined" className={classes.button} onClick={this.handleSave}>
                            Save
                        </Button>
                        <Button variant="outlined" className={classes.button} onClick={this.handleClose}>
                            Cancel
                        </Button>
                    </div>
                </Modal>
            </Paper>
        );
    }
}

function convertProjectsOptions(data, departmentId) {
    const options = data ? data.filter(findDepartmentId).map(data => ({
        label: data.ProjectName ? data.CompanyName + " - " + data.ProjectName : null + data.PipedriveJSON.title ? 'Deal Title: ' + data.PipedriveJSON.title : null,
        id: data.ProjectId,
        type: 'Projects'
    })) : [];

    function findDepartmentId(element) {
        if (element.ProgressStatus !== '4') {
            return true
        }
    }

    return options
}

function convertTasksOptions(data, projectId, userId) {
    const options = data ? data.filter(function (element) {
        if (element.ProjectId === projectId || ((projectId === '-1' || projectId.length === 0) && element.TaskType === 'PreTask' && element.AssignedToId === userId)) {
            return true
        }
        return false
    }).map(data => ({
        label: '[' + data.TaskType + '] ' + data.TaskName,
        id: data.TaskId,
        type: 'Tasks'
    })) : [];

    return options
}

function convertSubCategoryOptions(data) {
    const options = data ? data.filter(function (item) {
        return item.CommonStatus !== 'D' && item.CommonLocate !== 'TW'
    }).map(data => ({
        label: data.DefineValue1,
        id: data.CommonId,
        type: 'SubCategory'
    })) : [];

    return options
}

function RenderGameTheme(props) {
    return (
        <div>
            <img alt="background" src={imageUrl_SpiderWeb02} style={{
                position: 'absolute',
                zIndex: '-2',
                top: '0px',
                right: '-15px'
            }} />
            <img alt="background" src={imageUrl_KULO1} style={{
                position: 'absolute',
                zIndex: '-2',
                bottom: '17px',
                right: '45px',
                height: '70px'
            }} />
            <img alt="background" src={imageUrl_KULO2} style={{
                position: 'absolute',
                zIndex: '-2',
                bottom: '17px',
                right: '130px',
                height: '55px',
            }} />
            <img alt="background" src={imageUrl_Torch01} style={{
                position: 'absolute',
                zIndex: '0',
                bottom: '17px',
                right: '10px',
                height: '115px',
            }} />
        </div>
    );
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { users, projects, tasksissues, timesheet, common, Pagename } = state;

    return {
        user,
        users,
        projects,
        tasksissues,
        timesheet,
        common,
        Pagename
    };
}

FormComponent.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles, { withTheme: true }))(withCookies(FormComponent));


// WEBPACK FOOTER //
// ./src/components/Timesheet/FormComponent.js